import { useEffect, useState } from "react";

import { getDefaultConfigurationValues } from "@utils/search/defaultConfiguration";

import { AlgoliaTrackingService } from "@services/algolia/tracking/algoliaTracking.service";

import { useThunkDispatch } from "@redux/dispatcher";
import { set } from "@redux/modules/value/search/search.module";
import { SearchStatus } from "@redux/modules/value/search/search.types";

type useInitSearchProps = {
    searchFilters?: string;
    query?: string;
    categoryPagePaths?: Array<string>;
};

const useInitSearch = ({
    searchFilters,
    query,
    categoryPagePaths,
}: useInitSearchProps) => {
    const [initialized, setInitialized] = useState(false);

    const dispatch = useThunkDispatch();

    useEffect(() => {
        if (initialized) return;

        const handleSearchFilters = async () =>
            dispatch(
                set({
                    status: SearchStatus.Loading,
                    configuration: {
                        filters: searchFilters,
                        query: query,
                        userToken:
                            AlgoliaTrackingService.getAuthenticatedUserToken() ??
                            AlgoliaTrackingService.getUserToken(),
                        components: getDefaultConfigurationValues(),
                        categoryPagePaths: categoryPagePaths,
                    },
                }),
            );

        handleSearchFilters();
        setInitialized(true);
    }, [dispatch, initialized, setInitialized]);
};

export { useInitSearch };
